import { useCallback, useState } from "react";

import { confirmable } from "react-confirm";

import { handleClickForKeyboard } from "simplydo/core/accessibility";
import { Button, Icon, Modal } from "simplydo/react/ui";
import { Input } from "simplydo/react/ui";

type PromptModalProps = {
  show?: boolean;
  dismiss?: () => void;
  title: string;
  prompt: string;
  proceed: () => void;
  onComplete: (value: string) => void;
};

const PromptModal = ({
  show,
  dismiss,
  title,
  prompt,
  proceed,
  onComplete,
}: PromptModalProps) => {
  const [value, setValue] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  const complete = useCallback(() => {
    if (!value) return;

    if (!confirmed) {
      setConfirmed(true);
      onComplete(value);
      proceed();
    }
  }, [value, onComplete, proceed, confirmed]);

  return (
    <Modal
      open={!!show}
      onClose={dismiss ?? (() => {})}
      basic
      size="small"
      className="no-scroll"
      closeOnDimmerClick={false}
    >
      <Modal.Header content={title} />
      <Modal.Content>
        <p>{prompt}</p>
        <Input
          fluid
          placeholder="Please enter a value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleClickForKeyboard(complete, { keys: ["Enter"] })}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button basic inverted onClick={dismiss ?? (() => {})}>
          <Icon name="remove" /> Cancel
        </Button>
        <Button primary onClick={complete} disabled={!value}>
          <Icon name="checkmark" /> Confirm
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default confirmable(PromptModal);
